import PropTypes from 'prop-types'
import { find, omit } from 'lodash'
import { Radio, RadioGroup } from 'components/forms'
import { getHistory } from 'lib/history'
import { withRouter } from 'react-router'

const ProductSort = ({ setActiveSortParams, sortOptions, activeOption }) => {
  const handleChangeSort = (e) => {
    const history = getHistory({ useRouter: true })
    const location = history.getCurrentLocation()
    const sort = find(sortOptions, { value: e.target.value })
    const nextQuery = {
      ...omit(location.query, ['sort', 'order']),
      ...sort.params,
    }
    history.replace({
      pathname: location.pathname,
      query: nextQuery,
      state: location.state,
    })
    setActiveSortParams(sort.params)
  }

  return (
    <RadioGroup>
      {sortOptions.map((option) => (
        <Radio
          name="sort"
          size="large"
          key={option.value}
          label={option.label}
          value={option.value}
          onChange={handleChangeSort}
          defaultChecked={activeOption.value === option.value}
        />
      ))}
    </RadioGroup>
  )
}

ProductSort.propTypes = {
  sortOptions: PropTypes.array.isRequired,
  activeOption: PropTypes.object.isRequired,
  activeSortParams: PropTypes.object.isRequired,
  setActiveSortParams: PropTypes.func.isRequired,
}

export default withRouter(ProductSort)
